import { render } from "./ContactsSuppliers.vue?vue&type=template&id=7e00caa6&scoped=true"
import script from "./ContactsSuppliers.vue?vue&type=script&lang=js"
export * from "./ContactsSuppliers.vue?vue&type=script&lang=js"

import "./ContactsSuppliers.vue?vue&type=style&index=0&id=7e00caa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e00caa6"]])

export default __exports__